import React, {useState} from 'react';
import ReactDOM from 'react-dom/client';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import * as XLSX from 'xlsx';
import './index.css';
import {
    getPrestamosPorRol,
    getPrestamosPorCarrera,
    getPrestamosPorFondo,
    getPrestamosPorCategoriaDewey,
    getLibroMasPrestado,
    getNumeroPrestamosActivos,
    getNumeroTotalPrestamosEntreFechas,
    getNumeroTotalLibrosEnInventario,
    getNumeroTotalUsuariosRegistrados,
  } from '../../../services/EstadisticasService';
  import { getFeedbacks } from '../../../services/FeedBackService'; 
  import { RiFileExcel2Fill } from "react-icons/ri";



const DownloadEstadisticasExcel = () => {
    const MySwal = withReactContent(Swal);

    const handleDownloadExcel = async () => {
        let startDate = new Date(new Date().setDate(new Date().getDate() - 7));
        let endDate = new Date();

        const contentWrapper = document.createElement('div');
      
        await MySwal.fire({
          title: 'Selecciona el rango de fechas',
          html: contentWrapper,
          showConfirmButton: false,
          showCancelButton: false,
          cancelButtonText: 'Cancelar',
          willOpen: () => {
            const root = ReactDOM.createRoot(contentWrapper);
            root.render(
              <RangoFechasModal
                startDateInit={startDate}
                endDateInit={endDate}
                onSubmit={async ({ startDate, endDate }) => {
                  MySwal.close();
                  try {
                    await generarExcel(startDate, endDate);
                    Swal.fire({
                      title: '¡Excel generado!',
                      text: 'El archivo se ha descargado correctamente.',
                      icon: 'success',
                      confirmButtonColor: '#21807C',
                    });
                  } catch (error) {
                    Swal.fire({
                      title: 'Error',
                      text: 'No se pudo generar el Excel.',
                      icon: 'error',
                      confirmButtonColor: '#21807C',
                    });
                  }
                }}
              />
            );
          },
        });
      };


      const generarExcel = async (startDate, endDate) => {
        // Formatear las fechas
        const formattedStartDate = format(startDate, 'yyyy-MM-dd');
        const formattedEndDate = format(endDate, 'yyyy-MM-dd');
      
        const fileFormattedStartDate = format(startDate, 'dd-MM-yyyy');
        const fileFormattedEndDate = format(endDate, 'dd-MM-yyyy');
      
        // Mostrar un loader mientras se obtienen los datos
        Swal.showLoading();
      
        try {
          // Llamar a todas las funciones de estadísticas
          const [
            prestamosPorRol,
            prestamosPorCarrera,
            prestamosPorFondo,
            prestamosPorCategoriaDewey,
            libroMasPrestado,
            numeroPrestamosActivos,
            numeroTotalPrestamos,
            numeroTotalLibros,
            numeroTotalUsuarios,
            feedbacks,
          ] = await Promise.all([
            getPrestamosPorRol(formattedStartDate, formattedEndDate),
            getPrestamosPorCarrera(formattedStartDate, formattedEndDate),
            getPrestamosPorFondo(formattedStartDate, formattedEndDate),
            getPrestamosPorCategoriaDewey(formattedStartDate, formattedEndDate),
            getLibroMasPrestado(formattedStartDate, formattedEndDate),
            getNumeroPrestamosActivos(),
            getNumeroTotalPrestamosEntreFechas(formattedStartDate, formattedEndDate),
            getNumeroTotalLibrosEnInventario(),
            getNumeroTotalUsuariosRegistrados(),
            getFeedbacks(),
          ]);
      
          // Crear un libro de Excel
          const workbook = XLSX.utils.book_new();
      
          // Préstamos por Rol
          const prestamosPorRolSheet = XLSX.utils.json_to_sheet(prestamosPorRol);
          XLSX.utils.book_append_sheet(workbook, prestamosPorRolSheet, 'Préstamos por Rol');
      
          // Préstamos por Carrera
          const prestamosPorCarreraSheet = XLSX.utils.json_to_sheet(prestamosPorCarrera);
          XLSX.utils.book_append_sheet(workbook, prestamosPorCarreraSheet, 'Préstamos por Carrera');
      
          // Préstamos por Fondo
          const prestamosPorFondoSheet = XLSX.utils.json_to_sheet(prestamosPorFondo);
          XLSX.utils.book_append_sheet(workbook, prestamosPorFondoSheet, 'Préstamos por Fondo');
      
          // Préstamos por Categoría Dewey
          const prestamosPorCategoriaDeweySheet = XLSX.utils.json_to_sheet(prestamosPorCategoriaDewey);
          XLSX.utils.book_append_sheet(workbook, prestamosPorCategoriaDeweySheet, 'Préstamos por Temática');
      
          // Feedbacks - Formatear fechas
          const formattedFeedbacks = feedbacks.map(fb => ({
            ...fb,
            fechaCreacion: format(new Date(fb.fechaCreacion), 'dd/MM/yyyy HH:mm'),
          }));
          const feedbacksSheet = XLSX.utils.json_to_sheet(formattedFeedbacks);
          XLSX.utils.book_append_sheet(workbook, feedbacksSheet, 'Feedbacks');
      
          // Estadísticas Generales y Libro Más Prestado
          const estadisticasGenerales = [
            { 'Estadísticas': 'Número de Préstamos Activos', 'Valor': numeroPrestamosActivos },
            { 'Estadísticas': 'Número Total de Préstamos', 'Valor': numeroTotalPrestamos },
            { 'Estadísticas': 'Número Total de Libros en Inventario', 'Valor': numeroTotalLibros },
            { 'Estadísticas': 'Número Total de Usuarios Registrados', 'Valor': numeroTotalUsuarios },
          ];


          if (libroMasPrestado && Object.keys(libroMasPrestado).length > 0) {
            estadisticasGenerales.push(
              { 'Estadísticas': 'Libro Más Prestado', 'Valor': '' },
              { 'Estadísticas': 'Título', 'Valor': `${libroMasPrestado.nombre} ${libroMasPrestado.cantidad} préstamos` || 'N/A' },
            );
          } else {
            estadisticasGenerales.push(
              { 'Estadísticas': 'Libro Más Prestado', 'Valor': 'N/A' }
            );
          }
      
          const estadisticasGeneralesSheet = XLSX.utils.json_to_sheet(estadisticasGenerales);

      
          XLSX.utils.book_append_sheet(workbook, estadisticasGeneralesSheet, 'Estadísticas Generales');
      
          // Generar el archivo Excel
          const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      
          // Crear un Blob y descargar el archivo
          const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Estadisticas_${fileFormattedStartDate}_al_${fileFormattedEndDate}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('Error al generar el Excel:', error);
          throw error;
        } finally {
          Swal.hideLoading();
        }
      };
      
      
    
    return(
        <button onClick={handleDownloadExcel} className="download-excel-button">
            Descargar Estadísticas en Excel
            <RiFileExcel2Fill size={20}/>
        </button>
    )
}


const RangoFechasModal = ({ startDateInit, endDateInit, onSubmit }) => {
  const [startDate, setStartDate] = useState(startDateInit);
  const [endDate, setEndDate] = useState(endDateInit);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
      <label style={{ fontWeight: 'bold' }}>Fecha Inicio:</label>
      <DatePicker
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        dateFormat="dd/MM/yyyy"
        maxDate={endDate}
        className="swal2-input"
        placeholderText="Seleccione fecha de inicio"
      />
      <label style={{ fontWeight: 'bold' }}>Fecha Fin:</label>
      <DatePicker
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        dateFormat="dd/MM/yyyy"
        minDate={startDate}
        maxDate={new Date()}
        className="swal2-input"
        placeholderText="Seleccione fecha de fin"
      />
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '1rem' }}>
        <button
          className="swal2-cancel swal2-styled"
          style={{ backgroundColor: '#aaa' }}
          onClick={() => Swal.close()}
        >
          Cancelar
        </button>
        <button
          className="swal2-confirm swal2-styled"
          style={{ backgroundColor: '#21807C' }}
          onClick={() => onSubmit({ startDate, endDate })}
        >
          Generar Excel
        </button>
      </div>
    </div>
  );
};


export default DownloadEstadisticasExcel;